export default "__VITE_ASSET__65f74727__"